import BaseUserService from '../BaseUserService';
import moment from 'moment';
import Constants from '../../utils/constants';

const path = 'timehero/userReportedDay/month';
export default class MonthViewService extends BaseUserService {
    // Initializing important variables
    constructor() {
        super(path);
        this.path = path;
    }

    events(date) {
        let path = `${this.domain}/${this.path}/events?date=${moment(date).format(Constants.DATE_JSON_FORMAT)}`;
        return this.fetch(path, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        }).catch((err) => {
            throw err;
        });
    }
}
